// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // Initialize authData from localStorage if available
    const [authData, setAuthData] = useState(() => {
        try {
            const savedData = localStorage.getItem("dataLogin");
            return savedData ? JSON.parse(savedData) : null;
        } catch (error) {
            console.error("Error parsing saved auth data:", error);
            return null;
        }
    });

    // Initialize business from localStorage if available
    const [business, setBusiness] = useState(() => {
        return localStorage.getItem("business") || "";
    });

    // Custom setAuthData that also saves to localStorage
    const setAuthDataWithPersistence = (data) => {
        setAuthData(data);
        if (data) {
            localStorage.setItem("dataLogin", JSON.stringify(data));
        } else {
            localStorage.removeItem("dataLogin");
        }
    };

    // Custom setBusiness that also saves to localStorage
    const setBusinessWithPersistence = (businessCode) => {
        setBusiness(businessCode);
        if (businessCode) {
            localStorage.setItem("business", businessCode);
        } else {
            localStorage.removeItem("business");
        }
    };

    // Logout function to clear all auth data
    const logout = () => {
        setAuthData(null);
        setBusiness("");
        localStorage.removeItem("dataLogin");
        localStorage.removeItem("business");
        // Also clear cookies if needed
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    };

    return (
        <AuthContext.Provider value={{
            authData,
            setAuthData: setAuthDataWithPersistence,
            business,
            setBusiness: setBusinessWithPersistence,
            logout
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}; 